import * as React from 'react';
import { createSvgIcon } from '@material-ui/core/utils';
/**
 * @ignore - internal component.
 */

export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'NavigateNext');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/esm/internal/svg-icons/NavigateNext.js
// module id = 7371
// module chunks = 2